module.exports = __webpack_public_path__ + "img/account.rate.weekly.979351b3.png";